"use strict";

import { Time } from "../core/time.js";

export class Coroutine {
    constructor(enumerator) {
        this.enumerator = enumerator;
        this._done = false;
    }

    get isDone() { return this._done; }

    update() {
        if (this.other !== undefined) {
            if (!this.other.next().done) return 
            else this.other = undefined;
        }

        let result = this.enumerator.next();
        if (result.done) {
            Coroutine.stop(this);
            this._done = true;
        } else if (result.value != null) {
            this.other = result.value.update();
        }
    }

    //
    // Statics
    //
    static __coroutines = [];
    static start(coroutine) {
        if (coroutine == null) return;
        Coroutine.__coroutines.push(coroutine);
        coroutine.update();
        return coroutine;
    }
    static stop(coroutine) {
        if (coroutine == null) return;
        let indexOf = Coroutine.__coroutines.indexOf(coroutine);
        if (indexOf == -1) return;
        Coroutine.__coroutines.splice(indexOf, 1);
    }

    static _update() {
        for (let i = 0; i < Coroutine.__coroutines.length; i++) {
            if (Coroutine.__coroutines[i] != null) {
                Coroutine.__coroutines[i].update();
            }
        }
    }
}

export class WaitForSeconds {
    constructor(seconds) {
        this.endAt = Time.now + seconds;
    }

    *update() {
        while (this.endAt > Time.now) yield null;
    }
}

export class WaitUntil {
    constructor(check) {
        this.check = check;
    }

    *update() {
        while (!this.check?.()) yield null;
    }
}

export class DoWhileWaitForSeconds {
    constructor(seconds,doWhile) {
        this.endAt = Time.now + seconds;
        this.doWhile = doWhile;
    }

    *update() {
        while (this.endAt > Time.now) {
            this.doWhile?.();
            yield null;
        }
    }
}

export class DoWhile {
    constructor(check,doWhile) {
        this.check = check;
        this.doWhile = doWhile;
    }

    *update() {
        while (!this.check?.()) {
            this.doWhile?.();
            yield null;
        }
    }
}